import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function BackButton({ className = "" }) {
  const navigate = useNavigate();
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <button
        onClick={() => navigate(-1)}
        data-testid="back-btn"
        className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.15em] uppercase text-zinc-400 hover:text-yellow-400 transition-colors duration-200"
      >
        <ArrowLeft className="h-4 w-4" /> Indietro
      </button>
      <span className="h-3 w-px bg-zinc-700" />
      <button
        onClick={() => navigate("/")}
        data-testid="home-btn"
        className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.15em] uppercase text-zinc-400 hover:text-cyan-400 transition-colors duration-200"
      >
        <Home className="h-4 w-4" /> Home
      </button>
    </div>
  );
}
